import { LightBoxEvents } from "./lightbox_events.js"
import { setLightboxOpen, PixleeCarousel, HotspotsHelper, ReviewsHelper } from "./lightbox";
// NB. The previous decodeutf8 function had 3 levels of try/catch; this one has two.
import { decodeUtf8 } from "base/backbone/lib/utilities/helpers";

var DEFAULT_LIGHTBOX_VERSION = 'v1';
export var magnificPopup;
export var magnificPopupIndex = 0;
export var lightboxVersion;

// FEATURE TOGGLES
export var enableHotspots = false;
export var enableCarousel = false;
export var enableLightboxReviews = false;

let activeCtaIndex = 0;
let numberOfLinksBeforeProducts = 0;

function setActiveCtaIndex(index) {
    activeCtaIndex = index;
}

function setNumberOfLinksBeforeProducts(numberOfLinks) {
    numberOfLinksBeforeProducts = numberOfLinks;
}

function getActiveProductCta(products) {
    const productCtaIndex = activeCtaIndex - numberOfLinksBeforeProducts;
    if (productCtaIndex < 0 || productCtaIndex >= products.length) {
        return null;
    }
    return products[productCtaIndex];
}


window.addEventListener('message', function(event) {
    var eventData;
    if (event.data) {
        try {
            eventData = JSON.parse(event.data);
        } catch (error) {
            // Some other way of sending data, ignore
            return;
        }
    } else {
        return;
    }
    if (!eventData && !eventData.name) {
        return;
    }
    if (eventData.name === 'pixlee:close:lightbox') {
        $.magnificPopup.proto.close();
        closeLightbox();
    }
    if (eventData.name === 'pixlee:css:generated') {
        $.ajax({
            url: '/generatecss',
            type: 'POST',
            data: eventData.data,
            dataType: 'json',
            success: function(response) {
                $('#proserveStylesheet').html(response.proserve_css);
                $('#dynamicStylesheet').html(response.css);
            }
        });
    }
}, false);

export function setEnableReviews(data) {
    enableLightboxReviews = data;
}

export function setEnableHotspots(data) {
    enableHotspots = data;
}

export function setMagnificPopupIndex(data) {
    magnificPopupIndex = data;
}

export function setMagnificPopup(data) {
    magnificPopup = data;
}

export function setEnableCarousel(data) {
    enableCarousel = data;
}

function insertParam(url, paramName, paramValue) {
    if (url.indexOf(paramName + '=') >= 0) {
        var prefix = url.substring(0, url.indexOf(paramName));
        var suffix = url.substring(url.indexOf(paramName)).substring(url.indexOf('=') + 1);
        suffix = (suffix.indexOf('&') >= 0) ? suffix.substring(suffix.indexOf('&')) : '';
        url = prefix + paramName + '=' + paramValue + suffix;
    } else {
        if (url.indexOf('?') < 0) {
            url += '?' + paramName + '=' + paramValue;
        } else {
            url += '&' + paramName + '=' + paramValue;
        }
    }
    return url;
}

//meant to be of the form param1=val1&param2=val2
function insertParamString(url, paramString) {
    // trim anything leading
    if (paramString[0] === '&' || paramString[0] === '?') {
        paramString = paramString.substring(1);
    }

    if (url.indexOf('?' + paramString) < 0 && url.indexOf('&' + paramString) < 0) {
        if (url.indexOf('?') < 0) {
            url += '?' + paramString;
        } else {
            url += '&' + paramString;
        }
    }

    return url;
}

export function actionLinkFormatted(data) {
    if (_.isFalsy(data.action_link)) {
        return '';
    }
    return decodeUtf8(data.action_link);
}

export function captionFormatted(data) {
    var title;
    if (!_.isFalsy(data.title) || data.title === '') {
        title = data.title;
    } else if (!_.isFalsy(data.album_title)) {
        title = data.album_title;
    } else if (!_.isFalsy(data.photo_title)) {
        title = data.photo_title;
    }
    var decodedTitle = decodeUtf8(title);
    if (_.isFalsy(decodedTitle)) {
        return '';
    }
    return decodedTitle;
}

export function uploaderAdditionalFields(item, template) {
    var fields = item.data.uploader_additional_fields;
    var result = '';
    var targetContainer = template.find('#user_info_holder');

    if (!_.isEmpty(fields)) {
        var targetDivs = targetContainer.find('.additional_upload_info');

        //create a div for each additional field, with the key as an identifying class
        _.each(fields, function(field, index) {
            index = index.split(' ')[0]; //first word only for multi-word named fields
            // EN-6484: both the field key (used as a CSS class) and the user-supplied value are
            // inserted into the DOM, so HTML-encode both to prevent stored XSS.
            result += '<div class="additional_upload_info ' + escapeHtml(index) + '">' + escapeHtml(field) + '</div>';
        });

        //make sure we overwrite existing ones
        if (targetDivs.length) {
            targetDivs.remove();
        }

        targetContainer.append(result);
    }

}

export function actionLinkTextFormatted(data) {
    if (_.isFalsy(data.action_link_text)) {
        return '';
    }
    return decodeUtf8(data.action_link_text);
}

export function actionLinkPhotoFormatted(data) {
    if (_.isFalsy(data.action_link_photo)) {
        return '';
    }

    return decodeUtf8(data.action_link_photo);
}

function altText(currentItem) {
    var altText = '';
    if (!_.isFalsy(currentItem)) {
        if (!_.isFalsy(currentItem.alt_text)) {
            altText = currentItem.alt_text;
        } else if (!_.isFalsy(currentItem.content_type)) {
            if (!_.isFalsy(currentItem.user_name)) {
                altText = currentItem.content_type + ' by ' + currentItem.user_name;
            } else {
                altText = currentItem.content_type;
            }
        }
    }
    return decodeUtf8(altText);
}

function altTextProduct(title) {
    var altText = '';
    if (!_.isFalsy(title)) {
        altText = title + ' product';
    }
    return altText;
}

function productCategoryLabel(categories) {
    var categoryLabel = '';
    // The category label is the first category separated by a comma (",") as a delimiter
    if (typeof categories === 'string') {
        categoryLabel = categories.split(',')[0];
    }
    return categoryLabel;
}

export function submitterFormatted(data) {
    var submitter = 'Submitted by you';
    var source = data.source || 'desktop';

    if (data.user_name) {
        submitter = data.user_name;
    } else if (data.email_address) {
        submitter = data.email_address;
    }

    if (source === 'instagram' && !data.connected_user_id) {
        submitter = 'Instagram User';
    } else if (source === 'instagram' || source === 'twitter') {
        submitter = '@' + submitter.replace('@', '');
    }
    return submitter;
}

export function posterUrl(data) {
    return data.big_url || data.thumbnail_url;
}

export function videoURL(data) {
    var videoUrl = data.source_url || '';
    return videoUrl.replace('http://', 'https://');
}

export function submitterHref(data) {
    if (!_.isFalsy(data.platform_link)) {
        if (data.source === 'instagram' && data.platform_link.slice(-1) !== '/') {
            return data.platform_link + '/';
        } else {
            return data.platform_link;
        }
    }
    if (!_.isFalsy(data.submitter_link)) {
        return data.submitter_link;
    }
    switch (data.source) {
        case 'instagram':
            return 'http://instagram.com/' + data.submitterFormatted.replace('@', '');
        case 'twitter':
            return 'http://twitter.com/' + data.submitterFormatted.replace('@', '');
        case 'youtube':
            return 'https://www.youtube.com/channel/' + data.connected_user_social_id;
        case 'twitch':
            return 'https://twitch.tv/' + data.submitterFormatted;
        case 'tiktok':
            return 'https://tiktok.com/' + data.submitterFormatted;
        default:
            return 'javascript: void(0)';
    }
}

export function actionLinkTitleFormatted(data) {
    if (_.isFalsy(data.action_link_title)) {
        return '';
    }
    return decodeUtf8(data.action_link_title);
}

function getPhotoFileUrl(size, model) {
    // var bucket = 'pixlee-prod';
    // if (gon.global.env == 'development') {
    //     bucket = 'pixlee-dev';
    //     return 'http://s3.amazonaws.com/' + bucket + '/photos/' + model.id + '/' + size + '/' + App.reqres.request('encode:utf8', model.data_file_name);
    // }
    return 'https://static.pxlecdn.com/photos/' + model.id + '/' + size + '/' + encode_utf8(model.data_file_name);
}


function getPhotoThumbnailUrl(model) {
    if (!_.isFalsy(model.data_file_name)) {
        return getPhotoFileUrl('medium', model);
    }
    if (model.medium_url) {
        return model.medium_url.replace('http://', 'https://');
    } else if (model.thumbnail_url) {
        return model.thumbnail_url.replace('http://', 'https://');
    } else if (model.source_url) {
        return model.source_url.replace('http://', 'https://');
    }
}

function escapeHtml(string) {
    var entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        '\'': '&#39;',
        '/': '&#x2F;'
    };

    return String(string).replace(/[&<>'"\/]/g, function(s) {
        return entityMap[s];
    });
}

function getTitle(model) {
    if (gon.display_options.options && !gon.display_options.options.showCaptions) {
        return '';
    }
    if (!_.isFalsy(model.title) || model.title === '') {
        return model.title;
    }
    if (!_.isFalsy(model.album_title)) {
        return model.album_title;
    }
    if (!_.isFalsy(model.photo_title)) {
        return model.photo_title;
    }
    return false;
}

function encode_utf8(s) {
    var encoded_s = s;
    try {
        encoded_s = encodeURIComponent(s);
    } catch (e) {
        try {
            encoded_s = escape(s);
        } catch (error) {
            try {
                encoded_s = unescape(encodeURIComponent(s));
            } catch (error) {
                encoded_s = s;
            }
        }

    }
    return encoded_s;

}

function decode_utf8_link(s) {
    var decoded_s = s;
    try {
        decoded_s = decodeURIComponent(s);
    } catch (e) {
        try {
            decoded_s = unescape(s);
        } catch (e) {
            try {
                decoded_s = decodeURIComponent(escape(s));
            } catch (e) {
                decoded_s = s;
            }
        }
    }
    //quotes still need to be escaped
    decoded_s = decoded_s.replace(/\"/gi, '%22');
    return decoded_s;
}

/* Necessary check for carousel widgets with header tiles, see PR for deeper explanation.
 * Returns the index of the selected photo from the lightbox's photo collection;
 * Think of (indexToOpen - 1) as (indexToOpen - header tile index)
 */
export function getPhotoModelIndex(index, displayOptions) {
    var carouselWithHeaderTile = gon.type === 'carousel' && displayOptions.headerOptions.layout === 'tile';
    var indexToOpen = index;

    if (carouselWithHeaderTile && indexToOpen > 0) {
        indexToOpen = indexToOpen - 1;
    }

    return indexToOpen;
}

export function determineLightboxVersion(displayOptions) {
    lightboxVersion = displayOptions.lightbox_version || DEFAULT_LIGHTBOX_VERSION;
}

export function getSpinnerUrl(displayOptions) {
    var defaultSpinnerUrl = 'https://assets.pxlecdn.com/photos_loader_dont_delete/pixlee_mini_loader.gif';
    return displayOptions.hasOwnProperty('customSpinnerUrl') ? displayOptions.customSpinnerUrl : defaultSpinnerUrl;
}

//helper to find an active review within a product
function findActiveReview(reviews, selectedReviewInfo) {
    //checks if this product has the "active" review (i.e. the one on the gallery tile),
    //NOTE: every tile has a selected review, regardless of whether we show it or not (due to ADA compliance)
    var activeReview = _.find(reviews, function(review) {
        return review.id === selectedReviewInfo.id;
    });

    //if we found it, mark it so that we can activate the correct product in the lightbox carousel
    if (!_.isFalsy(activeReview)) {
        activeReview.active = true;
    }

    return activeReview;
}

//gets a review to show in the lightbox (active one if it exists, otherwise just the first)
function getReview(prod, selectedReviewInfo) {
    var review;
    //fetch all reviews for this product, or default fallback if there's none. First review is the default
    var reviews = prod.reviews_info && prod.reviews_info.reviews.length > 0 ? prod.reviews_info.reviews : [{
        id: 0,
        score: 0,
        user_name: '',
        title: '',
        content: '',
        active: false
    }];

    //if there's a active review in the tile for this photo, search this product to see if it belongs to it.
    //if we found it we know to select it and set this as the "active" product so it's featured in carousel.
    if (!_.isFalsy(selectedReviewInfo && selectedReviewInfo.active)) {
        review = findActiveReview(reviews, selectedReviewInfo);
    }

    //if not just fall back to showing a random review for each prod
    return review || reviews[Math.floor(Math.random() * reviews.length)];
}

// Takes a blob url and initiates a download
function triggerDownload(blobUrl, filename) {
    var downloadHelper = document.createElement('a');
    downloadHelper.download = decodeURIComponent(filename);
    downloadHelper.href = blobUrl;

    // Firefox needs element to be appended
    // 0 timeout is sufficient for click to go through
    // Ref: https://stackoverflow.com/a/30708820
    document.body.appendChild(downloadHelper);
    downloadHelper.click();
    setTimeout(function() {
        document.body.removeChild(downloadHelper);
        window.URL.revokeObjectURL(blobUrl);
    }, 0);
}

// Takes a URL and generates a download blob
function downloadUrl(url) {
    var filename = url.split('\\').pop().split('/').pop();
    var fetchError = function(error) {
        window.open(url);
        if (window.Sentry) {
            window.Sentry.captureMessage('Blob download failed. Opening media in new tab instead.', {
                level: 'warning',
                extra: {
                    type: typeof error,
                    eventData: error
                }
            });
        }
    };
    try {
        fetch(url + '?download=true', {
            headers: new Headers({
                'Origin': location.origin
            }),
            mode: 'cors'
        })
            .then(function(response) {
                return response.blob();
            })
            .then(function(blob) {
                var blobUrl = window.URL.createObjectURL(blob);
                triggerDownload(blobUrl, filename);
            })
            .catch(fetchError);
    } catch (error) {
        // for browsers that are not compatible with fetch (ie 11) catch error and open in new tab
        fetchError(error);
    }
}

export function linkLoaded(item) {
    if (item && item.products && item.products.length > 0) {

        var album_photo_id = item.album_photo_id;
        var rich_action = !_.isFalsy(item.products[0].image);

        LightBoxEvents.ActionLinkLoaded(album_photo_id, item.products.length, rich_action);
    }

}

//we need to create a closure in order to ensure that every function generated is under the correct scope
//due to it living inside of a loop it all needs to live right here within anon functions to work
function assignCTAOnclick(prodAnchor, product, albumId, type) {
    if (prodAnchor) {
        //if this product is the same as the current PDP, then the button should do something different
        // Skip "Continue Shopping" logic for all category albums
        var isCategoryAlbum = gon.current_album && gon.current_album.album_type === 'category';
        if ('products' === type && albumId === product.album_id && !isCategoryAlbum) {
            var prodAnchorEl = $(prodAnchor);
            var btnText = I18n.t('lightbox.cta.continue'); //if we ever wanted to let them customize, insert dispOpt here
            var richAction = prodAnchorEl.find('.cta_img').length > 0;

            prodAnchorEl.find('.product_cta, .cta_button').addClass('is_current_pdp').text(btnText);

            //rather than rewrite all the magnific popup logic, leverage the same button's event
            prodAnchor.onclick = function(ev) {
                LightBoxEvents.ActionLinkClicked(product.product_album_photo_id, product.link, btnText, richAction);

                $('.mfp-close').click();
                ev.preventDefault();
                return false;
            };
        } else {
            prodAnchor.onclick = (function(id) {
                return function() {
                    //pass the url instead of grabbing from table because this has gone through link formatting process already so
                    //it represents the exact page the users are going to hit
                    $.ajax({
                        url: gon.global.pixleePhotosServer + 'cta_valid',
                        data: {
                            productId: id,
                            formattedUrl: this.href //grab the exact url from anchor since it has gone through formatLink
                        },
                        type: 'post',
                        dataType: 'json'
                    });

                    //we don't really care when this finishes or if it succeeded so just move on
                    return true;
                };
            })(product.id);
        }
    }
}

export function filterProductsByDomain(validDomains, products) {
    var parentUrl = document.referrer;
    var currentDomain = '';

    var whitelistDomains = ['pixlee.com', 'pixlee.gallery', 'tap2shop', 'pixleeteam', 'socialfeed', 'feedshop'];
    for (var i = 0; i < whitelistDomains.length; i++) {
        if (parentUrl.indexOf(whitelistDomains[i]) > -1) {
            return products;
        }
    }

    for (var validDomain in validDomains) {
        if (validDomains.hasOwnProperty(validDomain)) {
            if (parentUrl.indexOf(validDomain) > -1) {
                // so that blah.com.au will match instead of blah.com
                if (validDomain.length > currentDomain.length) {
                    currentDomain = validDomain;
                }
            }
        }
    }

    //loop backwards so we don't mess up the indices as we splice the array
    for (var index = products.length - 1; index >= 0; index--) {
        if (_.isFalsy(currentDomain) || _.isFalsy(products[index].link) ||
            decode_utf8_link(products[index].link).indexOf(validDomains[currentDomain]) < 0) {
            products.splice(index, 1);
        }
    }

    return products;
}

export function filterProductsByPDP(currentAlbum, products) {
    products = products || [];

    var accountFeatures = gon.current_account.features;
    var hasReviews = _.isTruthy(gon.display_options.reviewOptions &&
        gon.display_options.reviewOptions.displayReviews);
    var disallowSelfLinks = !hasReviews && (_.isFalsy(accountFeatures) ||
        -1 === accountFeatures.indexOf('pdp_self_link'));

    //loop backwards so we don't mess up the indices as we splice the array
    for (var index = products.length - 1; index >= 0; index--) {
        if (disallowSelfLinks && products[index].album_id === currentAlbum.id) {
            products.splice(index, 1);
        }
    }

    return products;
}

function productHasDefaultCta(product) {
    return _._.isFalsy(product.link_text) || product.link_text === 'Buy Now';
}

function renderProductCTA(data, prodContainer, template, currentAlbum, displayOptions) {
    var products = _.clone(data.products);
    var templateData;
    var validDomains;
    var numAddedProducts = 0;
    var activeReview;

    //Don't show products on their own PDP page, unless that customer explicitly has it turned on (pdp_self_link)
    products = filterProductsByPDP(currentAlbum, products);

    // Assign the correct CTA link to each product, depending on the domain
    products = products.map(function(prod) {
        prod.link = formatLink(prod.link, currentAlbum, displayOptions, prod.extra_urls);
        return prod;
    });

    //check account for valid domain mappings
    if (!_.isFalsy(gon.current_account.extra_fields) && !_.isFalsy(gon.current_account.extra_fields.valid_product_domains)) {
        validDomains = gon.current_account.extra_fields.valid_product_domains;
    }

    //if the product is not from the whitelisted domains, remove it from the product array, and move on
    if (!_.isEmpty(validDomains)) {
        products = filterProductsByDomain(validDomains, products);
    }

    for (var i = 0; i < products.length; i++) {
        var product = products[i];
        var originalProduct = data.products[i];

        originalProduct.review = getReview(originalProduct, data.selectedReviewInfo);

        if (enableLightboxReviews) {
            template.find('#middle_block').addClass('reviews_active');
        }

        templateData = _.clone(product);
        templateData.image = product.custom_cta_photo;

        // If there's was custom qrCodeText set via a custom CTA use it or fall back on default qr label text
        templateData.qrCodeText = templateData.qrCodeText || I18n.t('lightbox.cta.qr_label');

        // if cta is default text, we can map it to the custom text from the DE or a localized version. Otherwise show custom cta text.
        if (productHasDefaultCta(product)) {
            templateData.link_text = I18n.t('lightbox.cta.buy_now');
        }

        // this means the product CTA is not customized in Lightbox Type options of Display Editor
        templateData.is_default_product_cta = true;

        if (_._.isFalsy(templateData.image)) {
            templateData.image = product.image_thumb ? product.image_thumb : product.image;
        }

        if (displayOptions.showProductDescription) {
            templateData.productDescription = product.description || '';
        }

        templateData.decode_utf8_link = decode_utf8_link;
        templateData.decode_utf8 = decodeUtf8;
        templateData.altTextProduct = altTextProduct;
        templateData.addClassIfTrue = addClassIfTrue;
        templateData.productCategoryLabel = productCategoryLabel;
        templateData.isFalsy = _.isFalsy;
        templateData.id = product.id || '';

        // this is where products get added to the CTA container
        // Verbose, but clearer and static readability preferred over dynamic templates
        numAddedProducts++;
        if (gon.isMobile) {
            if (lightboxVersion == 'v2') {
                prodContainer.append(require('./templates/v2/cta_mobile.jst.ejs')(templateData))
            }
            else {
                prodContainer.append(require('./templates/v1/cta_mobile.jst.ejs')(templateData))
            }
        }
        else if (gon.isDesktop) {
            if (lightboxVersion == 'v2') {
                prodContainer.append(require('./templates/v2/cta_desktop.jst.ejs')(templateData))
            }
            else {
                prodContainer.append(require('./templates/v1/cta_desktop.jst.ejs')(templateData))
            }
        }
        else if (gon.isTablet) {
            if (lightboxVersion == 'v2') {
                prodContainer.append(require('./templates/v2/cta_tablet.jst.ejs')(templateData))
            }
            else {
                prodContainer.append(require('./templates/v1/cta_tablet.jst.ejs')(templateData))
            }
        }

        //pass the current anchor and the product id so we can attach an onclick to each all during generation
        assignCTAOnclick(prodContainer.find('a')[i],
            templateData, data.album_id, displayOptions.album_type);

        if (displayOptions.qrCodeCta && prodContainer.find('#cta_qr').length) {
            // This is only displayed on desktop (#cta_qr not present on mobile/tablet)
            showQRCode(prodContainer.find('#cta_qr')[i], product.link);
        }

        //TODO: we can probably make a simpler version of the below, but this is robust enough for now. Lightbox in
        //general will be getting some love during hotspots work so no need to break this now. hide all except the first

        var ctaDivs = prodContainer.children();
        const ctaIndex = i + numberOfLinksBeforeProducts;

        if (ctaIndex) {
            var currentCta = $(ctaDivs[ctaIndex]);

            currentCta.addClass('invalid').attr('tabindex', '-1');

            //special case: reviews are enabled and we found a product with a active review.
            if (templateData.review && templateData.review.active) {
                setActiveCtaIndex(i + numberOfLinksBeforeProducts);
                ctaDivs.addClass('invalid').attr('tabindex', '-1'); // hide all
                currentCta.removeClass('invalid').attr('tabindex', '0'); // show this one
                activeReview = product;
            }
        } else {
            // this is index 0
            activeReview = product;
        }
    }

    if (enableLightboxReviews && activeReview) {
        ReviewsHelper.generateReview(activeReview, template);
    }
}

function resetCtaContainer(template) {
    return template.find('#cta_container').empty();
}

var addCta = function(obj, ctaContainer, template, displayOptions, isSecondaryCta = true) {
    if (_.isFalsy(obj.id)) {
        obj.id = '';
    }

    if (displayOptions.showProductDescription) {
        obj.productDescription = '';
    }

    obj.decode_utf8_link = decode_utf8_link;
    obj.decode_utf8 = decodeUtf8;
    obj.altTextProduct = altTextProduct;
    obj.addClassIfTrue = addClassIfTrue;
    obj.productCategoryLabel = productCategoryLabel;
    obj.isFalsy = _.isFalsy;

    // More verbose, but clearer and static readability preferred over dynamic templates
    if (gon.isMobile) {
        if (lightboxVersion == 'v2') {
            ctaContainer.append(require('./templates/v2/cta_mobile.jst.ejs')(obj))
        }
        else {
            ctaContainer.append(require('./templates/v1/cta_mobile.jst.ejs')(obj))
        }
    }
    else if (gon.isDesktop) {
        if (lightboxVersion == 'v2') {
            ctaContainer.append(require('./templates/v2/cta_desktop.jst.ejs')(obj))
        }
        else {
            ctaContainer.append(require('./templates/v1/cta_desktop.jst.ejs')(obj))
        }
    }
    else if (gon.isTablet) {
        if (lightboxVersion == 'v2') {
            ctaContainer.append(require('./templates/v2/cta_tablet.jst.ejs')(obj))
        }
        else {
            ctaContainer.append(require('./templates/v1/cta_tablet.jst.ejs')(obj))
        }
    }

    if (isSecondaryCta) {
        ctaContainer.children().last().addClass('invalid').attr('tabindex', '-1');
    }

    if (displayOptions.qrCodeCta && template.find('#cta_qr').length) {
        // This is only displayed on desktop (#cta_qr not present on mobile/tablet)
        showQRCode(template.find('#cta_qr')[0], obj.link);
    }
};

function updateCtaVisibility(template, hasImageOrProduct, enableCarousel) {
    // Update middle block styling based on whether there's an image
    if (_.isFalsy(hasImageOrProduct)) {
        template.find('#middle_block').addClass('simple_cta');
    } else {
        template.find('#middle_block').removeClass('simple_cta');
    }

    let ctaContainer = template.find('#cta_container');
    let linksCount = ctaContainer.children().length;

    var ctaSectionTitle = gon.display_options && gon.display_options.ctaSectionTitle;
    var ctaTitleEl = template.find('#cta_title');
    if (ctaTitleEl.length) {
        ctaTitleEl.text(linksCount > 0 && ctaSectionTitle ? ctaSectionTitle : '');
    }
    var tooManyLinks = linksCount > 6;

    //for themes where we don't use arrow navigation by default, we want to enable it after a threshold.
    //from what we've seen, the experience tends to break around 6 products so that's when we move to arrows.
    var prevArrow = template.find('#cta_prev');
    var nextArrow = template.find('#cta_next');

    if (prevArrow && nextArrow) {
        prevArrow.toggleClass('prevent_product_overflow_arrow', tooManyLinks);
        nextArrow.toggleClass('prevent_product_overflow_arrow', tooManyLinks);
    }

    if (ctaContainer) {
        ctaContainer.toggleClass('prevent_product_overflow', tooManyLinks);
    }

    //since we may have changed the length of this array, lets check again
    if (linksCount > 1) {
        showArrows(template);
    } else {
        hideArrows(template);
    }

    template.find('#middle_block, #cta_container, #cta_panel').toggle(linksCount > 0);
    template.find('#frame_large').toggleClass('has_cta', linksCount > 0);

    if (enableCarousel) {
        if (linksCount === 0) {
            // Show caption holder if no CTAs end up getting shown
            template.find('#caption_holder').show();
        } else {
            // If a CTA is shown in lightbox V2, hide the caption.
            template.find('#caption_holder').hide();
        }
        PixleeCarousel.setStartCtaIndex(activeCtaIndex, linksCount);
    } else if (enableHotspots) {
        HotspotsHelper.setCtaProductIndex(activeCtaIndex);
    }
}

function createCtaObject(link, text, title, image) {
    return {
        link: link,
        link_text: text,
        is_default_product_cta: false,
        image: image,
        title: title || '',
        review: {},
        price: '',
        currency: '',
        qrCodeText: text || I18n.t('lightbox.cta.qr_label'),
        showLowStock: false,
        incentivizedText: I18n.t('lightbox.incentivized')
    };
}

export function setOrReplaceCtaLinks(template, data, currentAlbum, displayOptions) {
    const ctaContainer = resetCtaContainer(template);

    setActiveCtaIndex(0);
    if (displayOptions.customCallToActionLink &&
        displayOptions.customCallToActionText &&
        displayOptions.showCallToAction &&
        // customCallToActionLinkBehaviour === "" means replace the existing CTAs with the custom CTA
        // If the custom call to action link behaviour is set to "", then then no other CTAs will be added and we can return early
        displayOptions.customCallToActionLinkBehaviour === '') {
        const cta = createCtaObject(
            displayOptions.customCallToActionLink,
            displayOptions.customCallToActionText,
            displayOptions.customCallToActionTitle,
            displayOptions.customCallToActionPhoto
        );
        addCta(cta, ctaContainer, template, displayOptions, false);
        updateCtaVisibility(template, displayOptions.customCallToActionPhoto ? true : false, enableCarousel);
    } else {
        setCtaLinks(ctaContainer, template, data, currentAlbum, displayOptions);
    }
}

function setCtaLinks(ctaContainer, template, data, currentAlbum, displayOptions) {
    let hasCta = false;
    let hasImageOrProduct = false;
    let linksBeforeProducts = 0;
    setActiveCtaIndex(0);
    if (data.links && data.links.length > 0) {
        data.links.forEach(function(link, index) {
            const cta = createCtaObject(
                link.url,
                link.link_text,
                link.description,
                link.image_url
            );

            addCta(cta, ctaContainer, template, displayOptions, hasCta);
            hasImageOrProduct ||= link.image_url ? true : false;
            hasCta = true;
            linksBeforeProducts++;
        });
    }
    // else if for backward compatibility
    else if (photoHasCta(data)) {
        const cta = createCtaObject(
            data.actionLinkFormatted,
            data.actionLinkTextFormatted,
            data.actionLinkTitleFormatted,
            data.actionLinkPhotoFormatted
        );
        addCta(cta, ctaContainer, template, displayOptions, hasCta);
        hasCta = true;
        hasImageOrProduct ||= data.actionLinkPhotoFormatted ? true : false;
        linksBeforeProducts++;
    }
    setNumberOfLinksBeforeProducts(linksBeforeProducts);
    // if there are products, we render the products CTA
    if (data.products.length > 0) {
        renderProductCTA(data, ctaContainer, template, currentAlbum, displayOptions);
        hasCta = true;
        hasImageOrProduct = true;
    }

    // we check if there is a Gallery CTA on the widget
    if (displayOptions.customCallToActionLink &&
        displayOptions.customCallToActionText &&
        displayOptions.showCallToAction) {
        const cta = createCtaObject(
            displayOptions.customCallToActionLink,
            displayOptions.customCallToActionText,
            displayOptions.customCallToActionTitle,
            displayOptions.customCallToActionPhoto
        );
        addCta(cta, ctaContainer, template, displayOptions, hasCta);
        hasCta = true;
        hasImageOrProduct ||= displayOptions.customCallToActionPhoto ? true : false;
    }

    updateCtaVisibility(template, hasImageOrProduct, enableCarousel);
}

/**
 * Handle the callbacks when someone clicks a CTA
 * or they toggle between different CTA options (ex: different products)
 */
export function initializeCtaClicks(currentAlbum, displayOptions, shouldListenToCarouselChange) {
    var initCta = function() {
        var mfp = magnificPopup || $.magnificPopup.instance;
        if (
            !mfp ||
            !mfp.items ||
            !mfp.items[magnificPopupIndex] ||
            !mfp.items[magnificPopupIndex].data
        ) {
            return;
        }
        var products = mfp.items[magnificPopupIndex].data.products;
        if (shouldGeneratePricingLayout(products)) {
            // We need to call this initially here to make sure pricing shows up the first time they open the lightbox
            products.forEach(function(p) {
                generatePricingLayout(p, displayOptions);
            });
            // TODO: this is pretty dumb and a hack until we use swiper for photos
            // Mobile uses Siema for the carousel, and we need a way to actually listen to the carousel changes
            // In desktop + tablet, users click on an arrow to select a new product, and that causes the markup to change
            // but for mobile, the entire markup is rendered at once, so we need to manually listen to change events
            // to update the markup accordingly
            if (shouldListenToCarouselChange) {
                $('#cta_container').off('carouselChange');
                $('#cta_container').on('carouselChange', function(_target, productIndex) {
                    generatePricingLayout(products[productIndex], displayOptions);
                });

            }
        }


        $('#cta_container').find('.cta_item_container').click(function() {
            var data = magnificPopup.items[magnificPopupIndex].data;

            var albumPhotoId = data.album_photo_id;

            var linkAnchor = $(this);
            var actionLinkUrl = linkAnchor.attr('href');
            var actionText = linkAnchor.find('.product_name, .cta_product_name').text();

            actionLinkUrl = formatLink(actionLinkUrl, currentAlbum, displayOptions);
            linkAnchor.attr('href', actionLinkUrl);

            var richAction = linkAnchor.find('.cta_img').length > 0;

            if (_.isFalsy(actionLinkUrl)) {
                return false;
            }

            /**
             * Setting tracking props for if low stock labels or discount pricing are present when a product is clicked.
             * Low stock / discount pricing only appear once the setDiscountAndStockTemplateVariables logic has been handled,
             * so we check to see if the corresponding classes are in the cta_item_container template
            **/
            var lowStock = linkAnchor.find('.product_stock').length > 0;
            var discountPricing = linkAnchor.find('.sales_price').length > 0;

            window.parent.postMessage(JSON.stringify({
                name: 'pixlee:cta:clicked',
                type: 'action',
                source: 'lightbox',
                destination: 'parent',
                data: {
                    ctaText: actionText,
                    ctaUrl: actionLinkUrl
                }
            }), '*');
            LightBoxEvents.ActionLinkClicked(
                albumPhotoId,
                actionLinkUrl,
                actionText,
                richAction,
                lowStock,
                discountPricing
            );

        });
    };

    /**
     * Anytime we change the active CTA item if there are multiple in the lightbox
     * NOTE: Mobile does not call this function yippe
     * This only applies when the user clicks a visible prev/next button in the CTA list (desktop/tablet only)
     */
    var scrollCtaList = function(direction) {
        var data = magnificPopup.items[magnificPopupIndex].data;
        var newCurrentCta;
        var anchors = $('#cta_container > a');
        var currentCta = anchors.not('.invalid');

        if (enableHotspots) {
            setActiveCtaIndex(HotspotsHelper.getCtaProductIndex() + numberOfLinksBeforeProducts);
        }

        linkLoaded(data);
        currentCta.addClass('invalid').attr('tabindex', '-1');

        if (direction === 'next') {
            if (currentCta.next().length === 0) {
                newCurrentCta = anchors.first();
                setActiveCtaIndex(0)
            } else {
                newCurrentCta = currentCta.next();
                setActiveCtaIndex(activeCtaIndex + 1);
            }
        } else {
            if (currentCta.prev().length === 0) {
                newCurrentCta = anchors.last();
                setActiveCtaIndex(anchors.length - 1);
            } else {
                newCurrentCta = currentCta.prev();
                setActiveCtaIndex(activeCtaIndex - 1);
            }
        }
        newCurrentCta.removeClass('invalid').attr('tabindex', '0');

        const activeProductCta = getActiveProductCta(data.products);

        if (enableCarousel) {
            // If carousel is enabled, it will handle hotspots and reviews
            PixleeCarousel.paginate(direction);
            /**
             * For Tablet, it uses HotspotsHelper which we reference to get the activeCtaIndex
             * BUT HotSpots helpers, IF theres a carousel (and on tablet there is), it references
             * lightbox_carousel to call hotspots helpers to set the index, which causes a race condition
             * which means, whenever we referenced activeCtaIndex BEFORE this line, it was before
             * lightbox_carousel had a chance to properly update for the new index
             */
            setActiveCtaIndex(HotspotsHelper.getCtaProductIndex() + numberOfLinksBeforeProducts);
        } else {
            if (enableLightboxReviews && activeProductCta) {
                ReviewsHelper.generateReview(activeProductCta);
            }

            if (enableHotspots) {
                HotspotsHelper.setCtaProductIndex(activeCtaIndex, true);
            }
        }

        if (activeProductCta && shouldGeneratePricingLayout(data.products)) {
            generatePricingLayout(activeProductCta, displayOptions);
        }

        var message = {
            name: 'pixlee:cta:changed',
            type: 'action',
            source: 'widget',
            destination: 'parent',
            data: {
                product: activeProductCta
            }
        };

        window.parent.postMessage(JSON.stringify(message), '*');
    };

    var ctaPrevButton = $('#cta_prev');
    var ctaNextButton = $('#cta_next');

    ctaPrevButton.unbind();
    ctaNextButton.unbind();

    ctaPrevButton.click(function() {
        scrollCtaList('prev');
    });

    ctaNextButton.click(function() {
        scrollCtaList('next');
    });
    initCta();
}

export function initializeClicks() {
    // subscribed event
    var socialShareEvent = function(model, socialNetworkName) {
        var productInfo = _.map(model.products, function(product) {
            return {
                name: decodeUtf8(product.title),
                sku: product.sku,
                imageUrl: decodeUtf8(product.image),
                linkUrl: decodeUtf8(product.link),
            };
        });

        var data = {
            name: 'pixlee:social:share',
            type: 'action',
            source: 'lightbox',
            destination: 'parent',
            data: {
                socialNetwork: socialNetworkName,
                products: productInfo
            }
        };

        window.parent.postMessage(JSON.stringify(data), '*');
    };

    $('.vote_button').click(function() {
        var data = magnificPopup.items[magnificPopupIndex].data;
        data.userVoted = true;
        data.voteText = I18n.t('widget.voted');
        delete data.close_replaceWith;
        delete data.img_replaceWith;

        var message = {
            name: 'pixlee:lightbox:vote',
            type: 'relay',
            source: 'lightbox',
            destination: 'widget',
            data: JSON.stringify(data)
        };
        var voteInterval = this.voteInterval || (gon.current_album && gon.current_album.vote_interval);
        var permanentVoteOptions = [undefined, null, '1 day', '1 week', '1 year'];
        //if we manually set the voted to be a few seconds (like we do for puma), then they get infinite voting

        if (permanentVoteOptions.indexOf(voteInterval) === -1) {
            //once the vote registers, then we remove the colour so they can immediately vote again
            setTimeout(function() {
                data.likeCount++;
                data.voteText = getVoteButtonText(I18n.t('widget.vote'), data.likeCount);
                data.userVoted = false;
                $.magnificPopup.instance.updateItemHTML();
            }, 1000);
        }

        window.parent.postMessage(JSON.stringify(message), '*');
        $.magnificPopup.instance.updateItemHTML();
    });
    $('#download_button').click(function(ev) {
        var model = magnificPopup.items[magnificPopupIndex].data;
        var url = ev.currentTarget.getAttribute('data');

        LightBoxEvents.DownloadClicked(model.album_photo_id);
        downloadUrl(url);
    });
    $('#tumblr_share').click(function() {
        var model = magnificPopup.items[magnificPopupIndex].data;

        LightBoxEvents.PhotoShared(model.album_photo_id, 'tumblr');
        socialShareEvent(model, 'tumblr');
        shareToSocialAction(model, 'tumblr');
    });
    $('#facebook_share').click(function() {
        var model = magnificPopup.items[magnificPopupIndex].data;

        LightBoxEvents.PhotoShared(model.album_photo_id, 'facebook');
        socialShareEvent(model, 'facebook');
        shareToSocialAction(model, 'facebook');
    });
    $('#pinterest_share').click(function() {
        var model = magnificPopup.items[magnificPopupIndex].data;

        LightBoxEvents.PhotoShared(model.album_photo_id, 'pinterest');
        socialShareEvent(model, 'pinterest');
        shareToSocialAction(model, 'pinterest');
    });
    $('#twitter_share').click(function() {
        var model = magnificPopup.items[magnificPopupIndex].data;

        LightBoxEvents.PhotoShared(model.album_photo_id, 'twitter');
        socialShareEvent(model, 'twitter');
        shareToSocialAction(model, 'twitter');
    });
    $('#report_button, #mobile_report_button').click(function() {
        var model = magnificPopup.items[magnificPopupIndex].data;
        LightBoxEvents.analyticsTrackClickReportButton(model.album_photo_id);
    });
}

function shareToSocialAction(photoJson, source) {
    var data = {
        name: 'pixlee:share:to:social',
        type: 'action',
        source: 'widget',
        destination: 'parent',
        data: {
            photoJson: photoJson,
            source: source,
        }
    };

    window.parent.postMessage(JSON.stringify(data), '*');
}

export function getVoteButtonText(text, likes) {
    if (gon.display_options.showVoteCount) {
        return I18n.t('widget.vote_count', {
            label: text,
            count: likes
        });
    } else {
        return text;
    }
}

function hideArrows(template) {
    template.find('#cta_prev, #cta_next').removeClass('active').attr('aria-hidden', 'true').attr('tabindex', '-1');
}

function showArrows(template) {
    template.find('#cta_prev, #cta_next').addClass('active').attr('aria-hidden', 'false').attr('tabindex', '0');
}

function showQRCode(qrCodeContainer, link) {
    if (qrCodeContainer) {
        qrCodeContainer.innerHTML = '';
        try {
            new QRCode(qrCodeContainer, {
                text: decode_utf8_link(link),
                width: 150,
                height: 150,
            });
        } catch (e) {
            console.error('Error generating qr code for url "' + link + '"', e);
        }
    }
}

// Helper to format links with specific schemes like dynamic tracking tags
export function formatLink(link, currentAlbum, displayOptions, extraURLs) {
    try {
        var referrerUrl = document.referrer;
        //assumes URL is in the form PROTOCOL://COUNTRY.brand.com
        if (!_.isFalsy(displayOptions.prepend_countries)) {
            var prepend = '';
            var protocol = '';
            var urlBody = '';
            referrerUrl = referrerUrl.split('://')[1];
            if (referrerUrl.indexOf('www') !== 0) {
                prepend = referrerUrl.split('.')[0];
                protocol = link.split('://')[0];
                urlBody = link.split('://')[1];
                if (urlBody.indexOf('www') === 0) {
                    urlBody = urlBody.substring(4);
                }
                if (urlBody.indexOf(prepend) !== 0) {
                    link = protocol + '://' + prepend + '.' + urlBody;
                }
            }
        }
        //assumes URL is in the form PROTOCOL://www.brand.com/COUNTRY/othershit
        if (!_.isFalsy(displayOptions.prepend_countries2)) {
            //basically if the referrer URL has some shit in between we want to put that on the link as well
            referrerUrl = referrerUrl.split('://')[1];
            var firstSlash = referrerUrl.indexOf('/');
            if (firstSlash > -1) {
                var secondSlash = referrerUrl.indexOf('/', firstSlash + 1);
                if (secondSlash > -1 && secondSlash - firstSlash < 5) { //possibly fragile
                    var append = referrerUrl.substring(firstSlash + 1, secondSlash);
                    //ok get the link prepend shit now
                    var spot = link.indexOf('.com/') + 4;
                    var suffix = link.substring(spot);
                    var prefix = link.substring(0, spot + 1);
                    link = prefix + append + suffix;
                }
            }
        }
        var country_map = displayOptions.country_map || gon.current_account.extra_fields.country_map;
        if (!_.isFalsy(country_map)) {
            // expected format for country map
            // country_map: {
            //     domain_name (e.g. 'munchkin.com/uk') : 'name of the key in extra_fields',
            // }
            //if extraurls gets passed as a string lets fix that
            try {
                extraURLs = JSON.parse(extraURLs);
            } catch (e) {

            }

            var matchedSubString = '';

            for (var countrySubString in country_map) {
                if (country_map.hasOwnProperty(countrySubString)) {
                    if (referrerUrl.indexOf(countrySubString) > -1) {
                        // so that blah.com.au will match instead of blah.com
                        if (countrySubString.length > matchedSubString.length) {
                            //if its empty we dont want to replace
                            link = extraURLs[country_map[countrySubString]] || link;
                            matchedSubString = countrySubString;
                        }
                    }
                }
            }
        }
        if (!_.isFalsy(displayOptions.url_scheme) || !_.isFalsy(gon.current_account.extra_fields.url_scheme)) {
            try {
                var newLink = link;
                var formatTitle = currentAlbum.title.replace(/ /g, '-').toLowerCase();
                var albumTitle = encodeURIComponent(encodeURIComponent(formatTitle));
                var urlScheme = displayOptions.url_scheme ?
                    displayOptions.url_scheme.url_scheme_title :
                    gon.current_account.extra_fields.url_scheme.url_scheme_title;

                switch (urlScheme) {
                    case 'kimpton_gacid':
                        newLink = insertParam(newLink, 'gacid', window.PixleeTags.Kimpton.GACID);
                        break;
                    case 'kcp_pixlee':
                        newLink = insertParam(newLink, 'om', 'pixlee:' + albumTitle + ':' + currentAlbum.id);
                        break;
                    case 'kcp_pixlee_v2':
                        newLink = insertParam(newLink, 'pixlee', albumTitle + ':' + currentAlbum.id);
                        break;
                    case 'zsupply':
                        newLink = insertParam(newLink, 'utm_source', 'pixlee');
                        newLink = insertParam(newLink, 'utm_medium', albumTitle);
                        break;
                    default:
                        var attributionString = displayOptions.url_scheme ?
                            displayOptions.url_scheme.attribution_string :
                            gon.current_account.extra_fields.url_scheme.attribution_string;
                        newLink = insertParamString(newLink, attributionString);
                }

                return newLink;

            } catch (e) {
                return link;
            }
        } else {
            return link;
        }
    } catch (e) {
        return link;
    }
}

export function modifyPBPDestination() {
    var landingPageURL = gon.current_account.extra_fields.landing_page_url;
    if (!_.isFalsy(landingPageURL)) {
        $('#powered_by_pixlee').attr('href', landingPageURL + '&utm_medium=widget-lightbox');
    }
}


/**
 * Converts seconds to format hHmMsS
 * ex: 1h30m45s
 */
function convertSecondsToTwitchTimeString(startTimeInSeconds) {
    startTimeInSeconds = startTimeInSeconds || 0;
    // This converts a string into a number, in case its not passed properly
    var hours = Math.floor(startTimeInSeconds / (60 * 60));
    var minutes = Math.floor(startTimeInSeconds / 60) % 60;
    var seconds = startTimeInSeconds % 60;

    return hours + 'h' + minutes + 'm' + seconds + 's';
}

/**
 * Sets an existing iframe.src to a specific twitch video
 * mediaId: Twitch Video ID
 * apiVideoOptions: {start time}. (Twitch does not support an end time for their players)
 */
export function initializeTwitchPlayer(mediaId, apiVideoOptions) {
    var startTime = convertSecondsToTwitchTimeString(apiVideoOptions.start);
    // NOTE: the console will show an error "t.channel is not implemented" this is safe to ignore
    // https://discuss.dev.twitch.tv/t/embedding-issues/21658/10

    // ---------- NOTE ----------
    // Twitch recently updated their embed API and made it mandatory to include all parent
    // domains where the embed code will be run so now we can include it in the iframe src
    // link => https://discuss.dev.twitch.tv/t/twitch-embedded-player-updates-in-2020/23956/120

    // add the domain of our iframe as parent
    var parentParams = '&parent=' + window.location.host;

    // add the main window's host as param
    if (gon.parentUrl) {
        // split the url into array, e.g. ["https:", "", "bananarepublic.gap.com"],
        // and take index 2 => 'bananarepublic.gap.com' aka the domain,
        parentParams += '&parent=' + gon.parentUrl.split('/')[2];
    } else {
        if (typeof Sentry != 'undefined') {
            Sentry.captureMessage('Parent url in gon does not exist');
        }
    }

    var twitchUrl = 'https://player.twitch.tv/?video=v' + mediaId + '&autoplay=true&time=' + startTime + parentParams;

    resetTwitchIframeSrc();

    /**
     * We're only able to acess the twitch_iframe because this document refers to the mfp iframe
     * This work around is specifically for compatibility with embedded widgets as you cannot directly try to access content
     * from inside another widget that has a domain than the parent one
     * */
    if (!this.twitchIframe) {
        this.twitchIframe = document.querySelector('#twitch_iframe');
    }

    this.twitchIframe.src = twitchUrl;
}

export function resetTwitchIframeSrc() {
    if (window.twitchIframe) {
        window.twitchIframe.src = '';
    }
}

/**
 * videoSettings: {start, end, thumbnail_name, thumbnail_url}
 * videoPlayerOptions: {autoplay,loop,sound}
 */
export function initializeYoutubeVideo(mediaId, videoSettings, videoPlayerOptions) {
    const that = this;
    const autoplay = videoPlayerOptions.autoplay ? 1 : 0;
    const start = videoPlayerOptions.start || 0;
    const end = videoPlayerOptions.end || 0;

    // Create an iframe directly (for the video itself).
    // To looping, both loop AND the playlist parameter are required: https://developers.google.com/youtube/player_parameters#loop
    $('#player').replaceWith(`<iframe id="player" type="text/html" width="620" height="620"
        src="https://www.youtube.com/embed/${mediaId}?enablejsapi=1&autoplay=${autoplay}&origin=${window.location.origin}&rel=0&start=${start}&end=${end}&loop=1&playlist=${mediaId}"
        frameborder="0"></iframe>`)

    // Add YouTube's embed script for later interactions, if we don't have one already.
    if (!document.getElementById("youtube_api_script")) {
        $("script").first().before('<script id="youtube_api_script" src="https://youtube.com/iframe_api"></script>');
    }

    window.onYouTubeIframeAPIReady = function() {
        that.youtubePlayer = new YT.Player('player', {
            events: {
                'onReady': onYoutubePlayerReady,
                'onStateChange': onYoutubeStateChange
            }
        });

        function onYoutubePlayerReady(ev) {
            that.youtubePlayer.unMute();
            that.youtubePlayer.setVolume(100);
            if (!videoPlayerOptions.sound) {
                ev.target.mute();
            }
            //direct links to videos make magnificpopup think there is an error. undo what it does
            $('.mfp-s-error').removeClass('mfp-s-error');
            $('.dead_image').remove();
            $('.mfp-preloader').hide();
        }

        function onYoutubeStateChange(ev) {
            if (ev && ev.data === 0 && videoPlayerOptions.loop) {
                that.youtubePlayer.seekTo(videoSettings.start || 0);
            }
        }
    }
}

export function initializeTiktokPlayer(platformLink) {
    function extractTikTokVideoId(url) {
        if (!url) {
            return null;
        }

        try {
            var parsed = new URL(url);
            var path = parsed.pathname || '';

            var playerMatch = path.match(/\/player\/v1\/(\d+)/);
            if (playerMatch && playerMatch[1]) {
                return playerMatch[1];
            }

            var embedMatch = path.match(/\/embed\/v2\/(\d+)/);
            if (embedMatch && embedMatch[1]) {
                return embedMatch[1];
            }

            var videoMatch = path.match(/\/video\/(\d+)/);
            if (videoMatch && videoMatch[1]) {
                return videoMatch[1];
            }
        } catch (e) {
            // Ignore parsing errors and fall back to regex extraction below
        }

        var looseMatch = String(url).match(/(?:\/player\/v1\/|\/video\/|\/embed\/v2\/)(\d+)/);
        return (looseMatch && looseMatch[1]) ? looseMatch[1] : null;
    }

    var deferred = $.Deferred();

    function waitForTikTokVideoContainer(timeoutMs) {
        var d = $.Deferred();
        var startedAt = Date.now();
        var intervalId;

        function check() {
            var $el = $('#pixlee_tiktok_video');
            if ($el.length) {
                d.resolve($el);
                return true;
            }

            if (Date.now() - startedAt >= timeoutMs) {
                d.reject('Timed out waiting for #pixlee_tiktok_video to exist in DOM');
                return true;
            }

            return false;
        }

        if (check()) {
            return d.promise();
        }

        intervalId = setInterval(function () {
            if (check()) {
                clearInterval(intervalId);
            }
        }, 50);

        return d.promise();
    }

    waitForTikTokVideoContainer(3000).done(function (tiktokVideo) {
        var videoId = extractTikTokVideoId(platformLink);

        if (!videoId) {
            var message = 'Unable to extract TikTok video id from URL: ' + platformLink;
            if (window.Sentry) {
                window.Sentry.captureMessage(message);
            } else {
                console.error(message);
            }
            tiktokVideo.empty();
            deferred.reject(message);
            return;
        }

        var videoOptions = (window.gon && gon.display_options && gon.display_options.videoOptions) ? gon.display_options.videoOptions : {};
        var params = new URLSearchParams();
        if (videoOptions.autoplay) {
            params.set('autoplay', '1');
        }
        if (videoOptions.loop) {
            params.set('loop', '1');
        }
        if (!videoOptions.sound) {
            params.set('muted', '1');
        }

        // TikTok Embed Player: https://www.tiktok.com/player/v1/{post_id}
        // See: https://developers.tiktok.com/doc/embed-player
        var src = 'https://www.tiktok.com/player/v1/' + videoId;
        var query = params.toString();
        if (query) {
            src += '?' + query;
        }

        tiktokVideo.html(`
            <iframe
                src="${src}"
                height="100%"
                width="100%"
                style="display:block;width:100%;height:100%;"
                frameborder="0"
                scrolling="no"
                allow="fullscreen; autoplay"
                allowfullscreen
            ></iframe>
        `);

        deferred.resolve({ videoId: videoId, src: src });
    }).fail(function (message) {
        if (window.Sentry) {
            window.Sentry.captureMessage(message);
        } else {
            console.error(message);
        }
        deferred.reject(message);
    });

    return deferred.promise();
}

/**
 * @param data {'Photo Response'}
 * @returns string
 */
function getContentSourceLink(data) {
    var hostName = 'https://static.pxlecdn.com';
    var src = '';


    if (data.data_file_name !== null) {
        src = hostName + '/photos/' + data.photo_id + '/original/' + data.data_file_name;
    } else if ((data.content_type === 'image' || !data.content_type) && data.source_url !== null) {
        src = data.source_url;
    } else if (data.content_type === 'video') {
        src = data.thumbnail_url;
    }

    return src.replace('http://', 'https://');
}

/**
 * As part of the instagram changes May 2020, some of the content we collect from instagram may be from 'anonymous' users
 * Unfortunately, we don't pass in the Entities.Photo so we can't reuse the logic there
 */
export function isAnonymousInstagram(data) {
    return !data.connected_user_id && data.source === 'instagram';
}

/**
 * magnific popup callback - called before magnific popup displays its contents
 * mfp will automatically assign properties to the markup directly by connecting css classes to properties in this item
 * Example:
 * <div class="mfp-avatarUrl"></div>
 * item.data.avatarUrl_src = 'https://avatar.com'
 *
 * mfp will automatically search for class names prefixed with mfp-, and any property in the item that matches a selector,
 * it will take the name after the last '_' and assign that to the markup.
 *
 * So for item.data.avatarUrl_src, mfp will find a matching element that has class=mfp-avatarUrl, and set the src to that markup
 *
 * <div class="mfp-avatarUrl" src="https://avatar.com"
 */
export function onElementParse(item, currentAlbum, spinnerUrl) {
    if (!item.src) {
        item.src = getContentSourceLink(item.data);
    }
    var url = (window.location !== window.parent.location) ? document.referrer : document.location.href;
    var shareLink = insertParam(url, 'pixlee_album_photo_id', item.data.album_photo_id);
    item.data.short_share_url = shareLink;

    item.data.vote_style = currentAlbum.campaign &&
        (gon.distinct_user_hash || window.analytics && window.analytics.getAnonymousId) ?
        '' : 'display:none;';

    // Link to instagram handle URL if it's an instagram story item
    var submitterHref = '';

    if (item.data.subtype === 'instagram_story' && item.data.source === 'instagram') {
        submitterHref = 'https://www.instagram.com/' + item.data.user_name;
    }

    item.data.submitterFormatted_href = submitterHref || item.data.submitterHref;

    // Required for incrementing votes in vote button text;
    // the actual vote button text is set in markupParse function
    item.data.likeCount = item.data.like_count;

    item.data.unreadCount = item.data.unread_count;
    item.data.nativeLikes = item.data.native_likes;
    item.data.captionFormatted = escapeHtml(item.data.captionFormatted);
    // EN-6484: submitter name/username is rendered into the lightbox via Magnific Popup's
    // `.html()` (the .mfp-submitterFormatted element), so it must be HTML-encoded to prevent
    // stored XSS. submitterHref is already computed above (lines ~1597 / lightbox.js:763) so
    // escaping here does not affect social profile links.
    item.data.submitterFormatted = escapeHtml(item.data.submitterFormatted);
    item.data.avatarUrl_alt = item.data.user_name + ' avatar';
    item.data.avatarUrl_src = item.data.avatar_url || '/assets/packs/static/embed/glyph/avatar@2x-09d53b880511d7919717.jpg';
    item.data.submitterSource_class = item.data.source + ' mfp-submitterSource';


    // If the content is tagged with a category of "incentivized" then its incentivized content
    // The gallery must also have the incentivized display option enabled
    var isIncentivized = false;
    if (gon.display_options.showIncentivizedBadge) {
        isIncentivized = _.some(item.data.categories, function(category) {
            return category.toLowerCase() === 'incentivized';
        });
    }

    item.data.incentivized = isIncentivized ? I18n.t('lightbox.incentivized') : '';
    item.data.incentivized_style = isIncentivized ? '' : 'display:none;';

    if (isAnonymousInstagram(item.data)) {
        item.data.userAvatar_class = 'mfp-userAvatar anonymous_instagram';
        item.data.avatarUrl_id = 'anonymous_instagram';
        item.data.avatarUrl_alt = I18n.t('lightbox.avatar.anonymous_user');
        item.data.avatarUrl_src = '';
    } else if (item.data.source === 'tiktok' && !item.data.avatar_url) {
        // item.data.avatar_url will not exist if tiktok user does not have a profile picture
        // Uses tiktok icon as avatar instead
        item.data.userAvatar_class = 'mfp-userAvatar tiktok_icon';
        item.data.avatarUrl_src = '';
        item.data.avatarUrl_id = '';
        item.data.avatarUrl_alt = I18n.t('lightbox.avatar.tiktok_user');
    } else { // Blank out styles that shouldn't apply.
        item.data.userAvatar_class = 'mfp-userAvatar';
        item.data.avatarUrl_id = '';
    }

    // if the photo is uploaded manually (desktop) then disable the click on username element
    // as there's no actual link to go to
    if (item.data.source === 'desktop') {
        item.data.submitterFormatted_style = 'pointer-events:none';
    } else {
        item.data.submitterFormatted_style = 'pointer-events:auto';
    }

    var dataSource = item.data.source;
    var dataContentType = item.data.content_type;
    var stylesToHide = {
        image: ['hideOnImage_style', 'hideOnYoutube_style', 'hideOnTwitch_style', 'hideOnTiktok_style'],
        video: ['hideOnVideo_style', 'hideOnYoutube_style', 'hideOnTwitch_style', 'hideOnTiktok_style'],
        youtube: [
            'hideOnVideo_style',
            'hideOnImage_style',
            'hideOnTwitch_style',
            'hideOnDownloadable_style',
            'hideOnTiktok_style'
        ],
        twitch: [
            'hideOnVideo_style',
            'hideOnImage_style',
            'hideOnYoutube_style',
            'hideOnDownloadable_style',
            'hideOnTiktok_style'
        ],
        tiktok: [
            'hideOnVideo_style',
            'hideOnImage_style',
            'hideOnYoutube_style',
            'hideOnTwitch_style',
            'hideOnDownloadable_style'
        ]
    };

    if (dataContentType === 'image') {
        item.data.hideOnDownloadable_style = '';
        item.data.download_data = item.data.pixlee_cdn_photos.original_url;
        item.data.downloadText = I18n.t('lightbox.download_image');
        item.data.hideOnVideo_style = 'background-image: url(\'' + item.src + '\')';
        stylesToHide = stylesToHide.image;
    } else if (dataSource === 'youtube') {
        item.data.hideOnYoutube_style = '';
        stylesToHide = stylesToHide.youtube;
    } else if (dataSource === 'twitch') {
        item.data.hideOnTwitch_style = '';
        stylesToHide = stylesToHide.twitch;
    } else if (dataSource === 'tiktok') {
        item.data.hideOnTiktok_style = '';
        stylesToHide = stylesToHide.tiktok;
    } else if (dataContentType === 'video') {
        item.data.hideOnDownloadable_style = '';
        item.data.download_data = item.data.source_url;
        item.data.downloadText = I18n.t('lightbox.download_video');
        item.data.video_poster = spinnerUrl;
        item.data.videoUrl_src = item.data.videoURL;
        item.data.hideOnImage_style = '';
        stylesToHide = stylesToHide.video;
    }
    stylesToHide.forEach(function(style) {
        item.data[style] = 'display:none;';
    });
    return item;
}

export function closeLightbox() {
    var data = {
        name: 'pixlee:hide:lightbox',
        type: 'action',
        source: 'lightbox',
        destination: 'all',
        data: {}
    };

    // Restore background content before tearing down the lightbox
    removeBackgroundInert();

    window.parent.postMessage(JSON.stringify(data), '*');
    if (this.currItem && this.currItem.data) {
        this.time = Date.now();
        this.lastItem = null;
    }


    if (this.videoPlayer) {
        this.videoPlayer.src('');
    }
    if (this.twitchPlayer) {
        $(this.twitchPlayer).remove();
    }
    magnificPopup = null;
    setLightboxOpen(false);
}

export function onLightboxUpdateStatus(data) {
    // Twitch causes some weird stuff to mfp where mangnific popup thinks theres no content and causes the mfp-preloader to cover the popup.
    // This line removes the 'no content' text that appears underneath the twitch video
    if (this.currItem.data.source === 'twitch') {
        data.status = 'ready';
    }
}

function addClassIfTrue(conditional, className) {
    if (conditional) {
        return ' ' + className;
    }
}

export function removeBodyClass(className) {
    if (document.body.classList.contains(className)) {
        document.body.classList.remove(className);
    }
}

/* Add or remove a class from the body in order to determines
 * whether the user is using a keyboard or mouse
 */
export function toggleUserNavigationClass(lightboxBody) {
    // off nameclass so it's not binded multiple times
    $(lightboxBody).off('.navigationClass');

    $(lightboxBody).on('keydown.navigationClass', function(e) {
        // remove mouse class if it exists
        removeBodyClass('using-mouse');

        // add keyboard class
        lightboxBody.classList.add('using-keyboard');

        if (enableHotspots) {
            HotspotsHelper.toggleHotspots(true);
        }

        // button elements already have a 'click' event
        if (e.keyCode === 13 && e.target.type !== 'button') {
            e.target.click();
        }
    });
    $(lightboxBody).on('mousedown.navigationClass', function() {
        // remove keyboard class if it exists
        removeBodyClass('using-keyboard');

        // add mouse class
        lightboxBody.classList.add('using-mouse');
    });
}

/* Use this to force focus on the first focusable element in the lightbox
* (typically when lightbox first loads)
* We need timeout in order to occur after timeout in pixlee:show:lightbox event in pixlee_widget.1.0.1
*/
export function initLightboxFocus() {
    setTimeout(function() {
        // Focus the dialog container so VoiceOver announces its accessible
        // name and places the virtual cursor at the top. This lets heading
        // navigation (VO+Cmd+H) find h2/h3 headings that follow in DOM order.
        // The close button remains the first Tab stop via normal tab order.
        var dialog = $('[role="dialog"]').first();
        if (dialog.length) {
            dialog.focus();
        } else {
            var closeBtn = $('.mfp-close');
            if (closeBtn.length) {
                closeBtn.focus();
            }
        }
    }, 1000);
}

/**
 * Makes background content inert when the modal opens.
 * Sets the `inert` and `aria-hidden` attributes on all siblings of
 * .mfp-wrap so VoiceOver/NVDA cannot reach elements behind the dialog.
 * Also moves the aria-live announcer inside the dialog so it continues
 * to work while aria-modal="true" is active.
 */
export function setBackgroundInert() {
    var mfpWrap = document.querySelector('.mfp-wrap');
    if (!mfpWrap) return;

    // Mark all body-level siblings of .mfp-wrap as inert
    var siblings = mfpWrap.parentNode.children;
    for (var i = 0; i < siblings.length; i++) {
        if (siblings[i] !== mfpWrap) {
            siblings[i].setAttribute('inert', '');
            siblings[i].setAttribute('aria-hidden', 'true');
        }
    }

    // Move the aria-live announcer inside the dialog so screen readers
    // can still hear slide-change announcements while aria-modal is active.
    var liveRegion = document.querySelector('.ariaLiveMessage');
    var dialog = document.querySelector('[role="dialog"]');
    if (liveRegion && dialog && !dialog.contains(liveRegion)) {
        dialog.appendChild(liveRegion);
    }
    if (liveRegion) {
        liveRegion.removeAttribute('inert');
        liveRegion.removeAttribute('aria-hidden');
    }
}

/**
 * Removes inert/aria-hidden from background content when the modal closes.
 */
export function removeBackgroundInert() {
    // Remove inert from any elements we previously marked
    var inertEls = document.querySelectorAll('body > [inert]');
    for (var i = 0; i < inertEls.length; i++) {
        inertEls[i].removeAttribute('inert');
        inertEls[i].removeAttribute('aria-hidden');
    }

    // Move aria-live announcer back to body so it's available for next open
    var liveRegion = document.querySelector('.ariaLiveMessage');
    if (liveRegion) {
        liveRegion.removeAttribute('inert');
        liveRegion.removeAttribute('aria-hidden');
        if (liveRegion.parentNode !== document.body) {
            document.body.appendChild(liveRegion);
        }
    }
}

export function hasMovedRight(prevIndex, currentIndex, lastIndex) {
    if (prevIndex === 0 && currentIndex === lastIndex) { // We were at the beginning and we went left (= all the way to the end)
        return false;
    }
    if (currentIndex === 0 && prevIndex === lastIndex) { // We were at the end and we went right (= all the way to the beginning)
        return true;
    }
    return currentIndex > prevIndex;
}

/**
 * Returns true if data representing an album photo has a custom CTA
 * @param data : data representing an album photo has a custom CTA
 */
export function photoHasCta(data) {
    return data.actionLinkFormatted && data.actionLinkTextFormatted;
}

/**
 * Sets a variety of variables related to discounts and stock onto the products for template displaying purposes
 * Related to Discount Pricing, and Low Stock
 * Sets the markup variables used in generatePricingLayout
 * Requires this to be called BEFORE generatePricingLayout
 * Called from lightbox, lightbox_mobile, lightbox_tablet, from onMarkupParse
 * Changes the products IN PLACE (pass by reference)
 * @param products
 * @param displayOptions
 * @returns
 */
export function setDiscountAndStockTemplateVariables(products, displayOptions) {
    return _.map(products, function(product) {
        var discountPrice = displayOptions.discountPrice;

        var currentTime = new Date().getTime();
        // Assume by default its true, because more often than naught, its more likely we dont get the start or end date atm
        var isWithinSalesDateRange = true;
        if (product.sales_start_date && !product.sales_end_date) {
            isWithinSalesDateRange = product.sales_start_date <= currentTime;
        } else if (!product.sales_start_date && product.sales_end_date) {
            isWithinSalesDateRange = product.sales_end_date >= currentTime;
        } else if (product.sales_start_date && product.sales_end_date) {
            isWithinSalesDateRange = product.sales_start_date <= currentTime && product.sales_end_date >= currentTime;
        }

        var salesPriceLessThanStandard = product.sales_price < product.price;

        product.discount_percentage = 0;
        if (displayOptions.discountLayout === 'with_discount_label') {
            product.discount_percentage = Math.round((1 - (product.sales_price / product.price)) * 100);
        }

        // Used for UI
        product.wasOldPriceLayout = displayOptions.discountLayout === 'was_old_price';
        product.stockLabelLayout = displayOptions.stockLabelLayout;

        // we show price if the displayOptions has productPrice true, and the product actually has an actual price > 0
        product.showPrice = displayOptions.productPrice && product.price;

        /**
         * Only show the sales price if its acceptable in case:
         *  - its a time based sale
         *  - the sales price is less than the standard price
         *  - theres actually a sales price > 0
         *  - we're also showing the price as well
         */
        product.showSalesPrice = isWithinSalesDateRange && discountPrice && salesPriceLessThanStandard && product.sales_price && product.showPrice;
        // Show the discount percentage if were showing the sales price, and discount percentage > 0
        product.showDiscountPercentage = product.showSalesPrice && product.discount_percentage;

        // Low stock is only shown in case stock is provided (often its null), and a stock threshold is provided (this often is null) is greater than the stock
        product.showLowStock = !!product.stock && displayOptions.stockThreshold >= product.stock;

        // if we're showing discount prices, we need to customize certain CSS depending on what the layout is
        product.priceCssClass = product.showSalesPrice ? displayOptions.discountLayout : '';
    });
}

function shouldGeneratePricingLayout(products) {
    return products && products.length && lightboxVersion !== DEFAULT_LIGHTBOX_VERSION;
}

/**
 * Generates the actual layout markup and inserts it into the page for items related to:
 * pricing, discount, and low stock
 * This is used in the initializeCtaClicks function
 * REQUIRES setDiscountAndStockTemplateVariables to have been called before
 * @param  product
 */
function generatePricingLayout(product) {
    var pricingHolder = $('.pricing_container[data-product-id="' + product.id + '"]');
    var pricingTemplate = require('./templates/pricing/_pricing.jst.ejs');
    pricingHolder.empty();
    var markup = pricingTemplate(_.extend(product, { decode_utf8: decodeUtf8 }));
    pricingHolder.append(markup);
}

export function isProductBadgeShown(product, displayOptions) {
    var hasProducts = product && product.length > 0;
    return hasProducts && !!displayOptions.productBadgeLayout;
}

export function getTikTokUrl(platformLink, mediaId, userName) {
    if (platformLink.startsWith('https://www.tiktok.com/')) {
        return platformLink;
    } else {
        return 'https://www.tiktok.com/@' + userName + '/video/' + mediaId;
    }
}
